import create from 'zustand';
import {InformationSriInterface} from "../interface/sri/information-sri-interface";

interface TaxPayerStorage {
    data?: InformationSriInterface | null;
    setData: (data: InformationSriInterface | null | undefined) => void;
}

export const useTaxPayerStorage = create<TaxPayerStorage>((set) => ({
    data: null,
    setData: (data: any) => set({ data }),
}));
